module.exports = __webpack_public_path__ + "img/video-poster-default.75138568.png";